import React, { useState, useEffect } from "react";
import "../style/chat_style.css";
import ChatFooterComponent from "./chat_footer_comp";
import ChatHeaderComponent from "./chat_header_comp";
import ChatBodyComponent from "./chat_body_comp";
import ChatCallComponent from "./chat_call_comp";
import ChatVideoCallComponent from "./chat_video_call_comp";
import ChatGalleryComponent from "./chat_gallery_comp";
import SubscriptionModalComponent from "./subscription_modal_comp";
import ClearChatModalComponent from "./clear_chat_modal_comp";
import { useSelector, useDispatch } from "react-redux";
import { chatActions } from "../../../di/di";
import { GalleryPhotoViewerComponent } from "./gallery_photo_viewer_comp";
import { menuActions } from "../../../di/di";

const ChatBackBoneComponent = () => {
  const dispatch = useDispatch();

  const showGallery = useSelector((state) => state.chat.showGallery);
  const showSubscriptionModal = useSelector((state) => state.chat.showSubscriptionModal);
  const showClearChatModal = useSelector((state) => state.chat.showClearChatModal);
  const showVideoCall = useSelector((state) => state.chat.showVideoCall);
  const showCall = useSelector((state) => state.chat.showCall);

  const handleCloseSubscriptionModal = () => {
    dispatch(chatActions.setShowSubscriptionModal(false));
  };

  const handleCloseClearChatModal = () => {
    dispatch(chatActions.setShowClearChatModal(false));
  };

  // Video call is unmounting when the screen is resizing, so we need to prevent the menu layout component to perform the resize functions
  useEffect(() => {
    dispatch(menuActions.disableResizeFunctions(showVideoCall || showCall));
  }, [showVideoCall, showCall]);

  return (
    <div className={"h-screen bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 text-white flex overflow-y-hidden"}>
      <div className={`h-dvh flex flex-col flex-grow relative ${showGallery ? "max-md:hidden" : ""}`}>
        <ChatHeaderComponent />
        <ChatBodyComponent />
        <ChatFooterComponent />
      </div>

      {/* Call */}
      <ChatCallComponent />

      {/* Video Call */}
      {showVideoCall && <ChatVideoCallComponent />}

      {/* Gallery */}
      <ChatGalleryComponent />

      {/* Gallery Photo Viewer */}
      <GalleryPhotoViewerComponent />

      {/* Subscription Modal */}
      {showSubscriptionModal && <SubscriptionModalComponent onClose={handleCloseSubscriptionModal} />}

      {/* Clear Chat Modal */}
      {showClearChatModal && <ClearChatModalComponent onClose={handleCloseClearChatModal} />}
    </div>
  );
};

export default ChatBackBoneComponent;
